<div class="flex-container">

  <div class="button-container">
    <mat-checkbox disabled [ngModel]="isChecked">
    </mat-checkbox>
  </div>

</div>
